<script setup lang="ts">
import { ref, watch, onMounted, computed } from "vue";
import { formatNumber, formatPercent } from "@/helpers/formatters";

const props = defineProps<{
    value: number | null | undefined;
    percent?: boolean;
    decimals?: number;
    markerLow?: number;
    markerHigh?: number;
    noPrefix?: boolean;
    title?: string;
}>();

const formattedValue = computed(() => {
    if (props.value == null || props.value === undefined) {
        return "";
    }
    if (props.percent) {
        return formatPercent(props.value, props.decimals ?? 2, props.noPrefix ? false : true);
    }
    return formatNumber(props.value, props.decimals ?? 2, props.noPrefix ? false : true);
});
</script>

<template>
    <span class="colored-number" v-if="value != null && value != undefined"
        :class="{
            '--negative': markerLow !== undefined ? value <= markerLow : value < 0,
            '--positive': markerHigh !== undefined ? value >= markerHigh : value > 0
        }"
        :title="title">{{formattedValue}}</span>
</template>

<style>
.colored-number.--positive {
    color: var(--teq-green);
}
.colored-number.--negative {
    color: var(--teq-red);
}
</style>
